const requiredParams = require("./requiredParams");

export {
  removeDuplicate,
  removeDuplicateObject,
  removeArrayFromArray,
  toInt,
  shuffleArray,
  pourArrayToAnotherArray
};

function removeDuplicate(array) {
  let result = [];
  if (!array) {
    return result;
  }

  let dict = {};
  let length = array.length;
  for (let i = 0; i < length; i++) {
    if (!dict[array[i]]) {
      result.push(array[i]);
      dict[array[i]] = 1;
    }
  }

  return result;
}

function removeDuplicateObject(array, key?) {
  let result = [];
  if (!array) {
    return result;
  }

  if (!key) {
    key = "id";
  }

  let dict = {};
  let length = array.length;
  for (let i = 0; i < length; i++) {
    if (array[i][key]) {
      if (!dict[array[i][key]]) {
        result.push(array[i]);
        dict[array[i][key]] = 1;
      }
    }
  }

  return result;
}

function removeArrayFromArray(myArray, toRemove) {
  return myArray.filter(function(el) {
    return toRemove.indexOf(el) < 0;
  });
}

function toInt({ array = requiredParams("array") }) {
  return array.map(e => parseInt(e)).filter(e => !isNaN(e));
}

//Fisher–Yates shuffle O(n)
function shuffleArray({ array }: { array: any[] }) {
  var m = array.length,
    t,
    i;

  // While there remain elements to shuffle…
  while (m) {
    // Pick a remaining element…
    i = Math.floor(Math.random() * m--);

    // And swap it with the current element.
    t = array[m];
    array[m] = array[i];
    array[i] = t;
  }

  return array;
}

function pourArrayToAnotherArray({
  firstArray = requiredParams("firstArray"),
  secondArray = requiredParams("secondArray"),
  minimumLengthFirstArray = requiredParams("minimumLengthFirstArray")
}) {
  let nbElementsToPour = minimumLengthFirstArray - firstArray.length;
  if (nbElementsToPour <= 0) {
    return { firstArray, secondArray };
  }

  nbElementsToPour = Math.min(nbElementsToPour, secondArray.length);
  for (let index = 0; index < nbElementsToPour; index++) {
    firstArray.push(secondArray.shift());
  }

  return { firstArray, secondArray };
}



// WEBPACK FOOTER //
// ./modules/toolbox/array.ts